'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactIntl = require('react-intl');
require('../../../../typography/ErrorText/ErrorText.js');
require('../../../../typography/LargeDarkText/LargeDarkText.js');
require('../../../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../../../typography/MediumDarkText/MediumDarkText.js');
require('../../../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../../../typography/MediumText/MediumText.js');
require('../../../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../../../typography/MiniatureLinkText/MiniatureLinkText.js');
var SmallDarkText = require('../../../../typography/SmallDarkText/SmallDarkText.js');
require('../../../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../../../typography/SmallDisabledText/SmallDisabledText.js');
var SmallEmphasizedDarkText = require('../../../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../../../typography/SmallLinkText/SmallLinkText.js');
var SmallTitleText = require('../../../../typography/SmallTitleText/SmallTitleText.js');
require('../../../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../../../typography/TinyDarkText/TinyDarkText.js');
require('../../../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../../../typography/TinyLinkText/TinyLinkText.js');
require('../../../../typography/TinyTitleText/TinyTitleText.js');
require('../../../../typography/XXLargeDarkText/XXLargeDarkText.js');
var styledComponents = require('./styled-components.js');
var StarScores = require('../../../../StarScores/StarScores.js');

var RatingBubbleAndText = function (_a) {
    var recommendationType = _a.recommendationType;
    var fm = reactIntl.useIntl().formatMessage;
    return (React__default.createElement(styledComponents.RatingBubble, { positive: recommendationType === 'positive' },
        React__default.createElement(styledComponents.RecommendationText, null, recommendationType === 'positive'
            ? fm({ id: 'componentLib.reviews.recommended' })
            : fm({ id: 'componentLib.reviews.notRecommended' })),
        React__default.createElement(styledComponents.SpeechBubble, { positive: recommendationType === 'positive' },
            React__default.createElement(styledComponents.StarContainer, null, " \u2605"))));
};
var Response = function (props) {
    var _a = props.name, name = _a === void 0 ? 'Anonymous' : _a, createdAt = props.createdAt, _b = props.text, text = _b === void 0 ? '' : _b, score = props.score, type = props.type, _c = props.recommendationType, recommendationType = _c === void 0 ? 'positive' : _c;
    return (React__default.createElement(styledComponents.ResponseContainer, null,
        React__default.createElement("div", null,
            React__default.createElement(SmallEmphasizedDarkText, { style: { marginBottom: type === 'google' ? '6px' : 0, color: '#4C506C' } }, name),
            React__default.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', alignItems: 'center' } },
                React__default.createElement("span", { style: { verticalAlign: 'top' } },
                    type === 'google' && React__default.createElement(StarScores, { averageRating: score, fontSize: '0.7em' }),
                    type === 'facebook' && React__default.createElement(RatingBubbleAndText, { recommendationType: recommendationType })),
                React__default.createElement(SmallTitleText, { style: { paddingLeft: '0.5rem' } }, createdAt.fromNow())),
            React__default.createElement(SmallDarkText, { style: { margin: '0px', color: '#606D7E', fontSize: '0.93em' } }, text))));
};

module.exports = Response;
